// フォーマットカテゴリタイプ　要共通化。
export enum FormatCategoryKinds {
  Digital = "0",
  Paper = "1", // 紙
}
